import { canAccessAiUsage } from "@/route/aiUsageAccess";
import { useAppSelector } from "@/store/hooks";
import { getClientID } from "@/utils/authUtils";
import { useOwnAccountRole } from "./useOwnAccountRole";

export const useAiUsageAccess = (): {
  canAccess: boolean;
  loading: boolean;
} => {
  const { accountRole, loading: accountRoleLoading } = useOwnAccountRole();
  const { data, isFetching, error } = useAppSelector(
    (state) => state.clients.detailed,
  );
  const hasClientData = Object.keys(data ?? {}).length > 0;
  const waitingForClient =
    Boolean(getClientID()) && !hasClientData && !error;

  return {
    canAccess: canAccessAiUsage(accountRole, data?.client_services),
    loading: accountRoleLoading || isFetching || waitingForClient,
  };
};

export default useAiUsageAccess;
